const Line = ({ width = "100%", className = "" }) => <span className={`cardora-skeleton skeleton-line ${className}`} style={{ width }} aria-hidden="true" />;
const Block = ({ className = "" }) => <span className={`cardora-skeleton ${className}`} aria-hidden="true" />;

export function FeedSkeleton({ count = 3 }) {
  return <div className="loading-feed" aria-label="Cargando publicaciones" aria-busy="true">
    {Array.from({ length: count }, (_, index) => <article className="loading-feed-card" key={index}>
      <div className="loading-feed-head"><Block className="skeleton-avatar" /><div><Line width="42%" /><Line width="26%" className="is-small" /></div><Block className="skeleton-chip" /></div>
      <Line width="94%" /><Line width={index % 2 ? "68%" : "78%"} />
      {index === 0 && <Block className="skeleton-feed-media" />}
      <div className="loading-feed-actions"><Block className="skeleton-button" /><Block className="skeleton-button" /></div>
    </article>)}
  </div>;
}

export function ProfileSkeleton({ compact = false }) {
  return <div className={`loading-profile ${compact ? "is-compact" : ""}`} aria-label="Cargando perfil" aria-busy="true">
    <section className="loading-profile-hero"><Block className="skeleton-profile-avatar" /><div><Line width="42%" className="is-title" /><Line width="68%" /><div className="loading-chip-row"><Block className="skeleton-chip" /><Block className="skeleton-chip" /><Block className="skeleton-chip" /></div></div><Block className="skeleton-profile-action" /></section>
    {!compact && <><div className="loading-tab-row"><Block className="skeleton-tab" /><Block className="skeleton-tab" /><Block className="skeleton-tab" /><Block className="skeleton-tab" /></div><CardGridSkeleton count={4} /></>}
  </div>;
}

export function BinderSkeleton() {
  return <div className="loading-binder" aria-label="Cargando binder" aria-busy="true">
    <div className="loading-binder-toolbar"><Line width="28%" className="is-title" /><div><Block className="skeleton-button" /><Block className="skeleton-button" /><Block className="skeleton-button" /></div></div>
    <div className="loading-binder-layout"><aside><Block className="skeleton-card-preview" /><Line width="76%" /><Line width="48%" /></aside><div className="loading-binder-page">{Array.from({ length: 9 }, (_, index) => <Block className="skeleton-binder-pocket" key={index} />)}</div></div>
  </div>;
}

export function CardGridSkeleton({ count = 6 }) {
  return <div className="loading-card-grid" aria-label="Cargando contenido" aria-busy="true">
    {Array.from({ length: count }, (_, index) => <article className="loading-grid-card" key={index}><Block className="skeleton-grid-image" /><Line width="72%" /><Line width="46%" className="is-small" /></article>)}
  </div>;
}

export function DirectorySkeleton() {
  return <div className="loading-directory" aria-label="Cargando comunidades" aria-busy="true">
    <div><Line width="32%" className="is-title" /><Line width="58%" /></div>
    <div className="loading-metrics">{Array.from({ length: 3 }, (_, index) => <Block className="skeleton-metric" key={index} />)}</div>
    <Block className="skeleton-search" />
    <CardGridSkeleton count={6} />
  </div>;
}
